/**
 * Feature flags for UI exposure.
 *
 * SHOW_TRIAL_PLAN: お試し（¥500 / 80クレジット単発購入）プランの表示切替。
 * false = UI から非表示（プラン自体・Stripe Price/Product・既存購入者の
 * クレジットと権利はそのまま温存。購入導線のみ隠す）。
 * 再表示したい場合は true に戻すだけでOK。
 */
export const SHOW_TRIAL_PLAN = false;
